import {APIResponseType} from "../../../api/types";
import {instance} from "../../../api/agent";

export type PaymentType = {
    payNumber: string
    payDate: string
    payType: number
    isFree: boolean
}

type PaySearchRoute = {
    route: string
    isMatch: boolean
}

export const api = {
    getPayment() {
        return instance.get<APIResponseType<PaymentType>>(`pay/checkpay`)
            .then(res => res.data)
    },
    checkPay(payNumber: string, payDate: string, payType: string) {
        return instance.post<APIResponseType<PaySearchRoute>>(`pay/checkpay`, {payNumber, payDate, payType})
            .then(res => res.data)
    }
}